import React from 'react';
import { Route } from 'react-router-dom';
import { graphql, compose } from 'react-apollo';

import UserList from 'Components/Presentation/Users/UserList';
import UserEditContainer from './Edit';

import AllUsersQuery from 'GraphQueries/Users/AllQuery';
import NewUserMutation from 'GraphQueries/Users/NewMutation';
import NewUserSubscription from 'GraphQueries/Users/NewSubscription';
import DeleteUserMutation from 'GraphQueries/Users/DeleteMutation';
import UserDeleteSubscription from 'GraphQueries/Users/DeleteSubscription';

class UserIndexContainer extends React.Component {

    static defaultProps = {
        users: [],
        loading: false
    }

    state = {
        user: null
    }

    componentDidMount() {
        this.props.subscribeToChanges();
    }

    saveUser = async (user) => {
        this.props.onAdd(user).then(response => {
            const { createUser } = response.data;
            this.navigateWithData(`/system/users/${createUser.id}/manage/settings`, createUser);
        }).catch(err => console.log(err));
    }

    deleteUser = async (user) => {
        await this.props.onDelete(user);
    }

    navigateWithData = (uri, user) => {
        const { history } = this.props;
        this.setState({ user });
        history.push(uri);
    }

    render() {
        const { users, loading } = this.props;
        const { user } = this.state;
        return (
            <React.Fragment>
                <Route path="/system/users" exact render={props => {
                    return (
                        <UserList {...props} loading={loading} onEdit={this.navigateWithData} users={users}
                            onUserAdded={this.saveUser} onUserRemoved={this.deleteUser} />
                    )
                }
                } />
                <Route path="/system/users/list" render={props => {
                    return (
                        <UserList {...props} loading={loading} onEdit={this.navigateWithData} users={users}
                            onUserAdded={this.saveUser} onUserRemoved={this.deleteUser} />
                    )
                }
                } />
                <Route path="/system/users/:id/manage" render={props => {
                    return (
                        <UserEditContainer user={user}  {...props} />
                    )
                }
                } />
            </React.Fragment>
        );
    }
}

export default compose(
    graphql(AllUsersQuery, {
        props: (props) => ({
            users: props.data.listUsers && props.data.listUsers.items,
            loading: props.data.loading,
            subscribeToChanges: params => {
                props.data.subscribeToMore({
                    document: NewUserSubscription,
                    updateQuery: (prev, { subscriptionData: { data: { onCreateUser } } }) => ({
                        ...prev,
                        listUsers: { items: [onCreateUser, ...prev.listUsers.items.filter(item => item.id !== onCreateUser.id)], __typename: 'User' }
                    })
                });
                props.data.subscribeToMore({
                    document: UserDeleteSubscription,
                    updateQuery: (prev, { subscriptionData: { data: { onDeleteUser } } }) => ({
                        ...prev,
                        listUsers: { items: [...prev.listUsers.items.filter(item => item.id !== onDeleteUser.id)], __typename: 'User' }
                    })
                });
            }
        }),
    }),
    graphql(DeleteUserMutation, {
        props: (props) => ({
            onDelete: (user) => props.mutate({
                variables: { id: user.id, version: user.version },
                optimisticResponse: () => ({ deleteUser: { ...user, __typename: 'User' } }),
            })
        }),
        options: {
            refetchQueries: [{ query: AllUsersQuery }],
            update: (proxy, { data: { deleteUser: { id, version } } }) => {
                const query = AllUsersQuery;
                const data = proxy.readQuery({ query });

                data.listUsers.items = data.listUsers.items.filter(user => user.id !== id && user !== version);

                proxy.writeQuery({ query, data });
            }
        }
    }),
    graphql(NewUserMutation, {
        props: (props) => ({
            onAdd: user =>
                props.mutate({
                    variables: { ...user },
                })
        }),
        options: {
            refetchQueries: [{ query: AllUsersQuery }],
            update: (dataProxy, { data: { createUser } }) => {
                const query = AllUsersQuery;
                const data = dataProxy.readQuery({ query });

                data.listUsers.items.push(createUser);
                dataProxy.writeQuery({ query, data });
            }
        }
    })
)(UserIndexContainer);


// WEBPACK FOOTER //
// ./src/Components/Containers/Users/Index.js